import React from 'react'
import mac from "../Davidayo/img/david.png"
import web from "../Davidayo/img/david2.png"
import gif from "../Davidayo/img/dayogif.gif"
import Image from "../../../../Components/Image"


function DavidAyo() {
    return (
        <div className=" animated fadeInIn">
            <div id="work_content">
                <div className="work_title">David Ayo</div>
                <div className="work_type">Web Application</div>
                <div className="process_title">
                    Overview
                </div>
                <div className="process_text">
                    <p>
                        Hey there,
                        <br />
                        So I am finally putting this out! For a while now I struggled with creating a suitable portfolio. There was never the right time for it. But even if I had time, I always had a different idea on how it should look and feel. It was a never-ending story.
                        <br />
                        This year I decided I would put in effort and try! So I finally took two days off to just implement something simple but suitable enough for me and everyone else interested in knowing me.
                    </p>
                </div>
            </div>
            <div id="images">
                <Image src={mac} />
            </div>
            <div id="work_content">
                <div className="process_title">
                    Process
                </div>
                <div className="process_text">
                
                    <p>
                        The main design of the application is based off of various ideas i have picked up over the years but coined in a unique way that potrays my own ideas.<br/>
                        I had always known that if I were to make a minimal portfolio I would put tiny details that described me, like:
                        <ul>
                            <li>My love for the color green (army green).</li>
                            <li>Have little Memoji's of myself.</li>
                            <li>Include hidden gamified animations around.</li>
                            <li>Give the App a warm and not so boring feel regardless of it's simplicity.</li>
                        </ul>
                        I did an initial sketch using AdobeXD which made sense to me and eventually turned out to be the main layout for the App.<br/>
                        During development alot of different ideas popped in, some were discarded, some made it,  while the others will be implemented later on.

                    </p>
                    <p>
                        The application design is implemented almost solely in CSS. All animations and transitions are CSS animations. While the javascript framework used is ReactJs.
                    </p>
                </div>
            </div>
            <div id="images">
                <Image src={gif} />
            </div>
            <div id="work_content">
                <div className="process_title">
                    Resources
                </div>
                <div className="process_text">
                    <p>
                        <div className="dev_title">Front End</div>
                        <div className="dev_info"> React, SASS, CSS Animate etc.</div>
                    </p>
                </div>
            </div>
            <div id="images">
                <Image src={web} />
            </div>
        </div>
    )
}

export default DavidAyo